import {
  Avatar,
  Badge,
  Box,
  Button,
  ButtonGroup,
  Center,
  Divider,
  Flex,
  Icon,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Spinner,
  Text,
  Tooltip,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import axios from "axios";
import { formatDistance } from "date-fns";
import { useState } from "react";
import { BsDot, BsThreeDotsVertical } from "react-icons/bs";
import {
  FaArchive,
  FaArrowLeft,
  FaCalendar,
  FaCheckDouble,
  FaRobot,
} from "react-icons/fa";
import { IoMdNotifications } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import {
  clearUserNotifications,
  deleteUserNotification,
  fetchUserNotifications,
  readAllUserNotifications,
  readUserNotification,
  resetNotification,
} from "../../_actions/notificationActions";
import { useTranslation } from "react-i18next";
import TLDRInfiniteScroll from "./TLDRInfiniteScroll";
import { useEffect } from "react";
import { wsNotification } from "../../_actions/webSocketAction";
import { MdSettings } from "react-icons/md";
import { ShowCenterSpinner } from "./statelessView";
import { Fragment } from "react";

const menuButtonStyle = {
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  color: "gray.100",
};

const menuStyle = {
  width: "32px",
  height: "32px",
  _hover: {
    background: "gray.1000",
  },
  _active: {
    background: "gray.1000",
  },
};

const menuListStyle = {
  width: "412px",
  maxH: "478px",
  background: "brand.dark_04",
};

const itemActionStyle = {
  width: "125px",
  maxH: "72px",
  pt: "3px",
};

const readAllBtnStyle = {
  background: "transparent",
  padding: 0,
  height: "100%",
  fontWeight: "400",
  textDecoration: "underline",
  justifyContent: "right",
  h: "4",
  w: "4",
  minW: "4",
  "&:hover": {
    background: "transparent",
    color: "brand.primary",
  },
  _active: {
    background: "transparent",
  },
  _disabled: {
    background: "transparent",
    color: "gray.300",
    cursor: "not-allowed",
  },
};

const dividerStyles = {
  borderWidth: "1px",
  borderColor: "gray.1000",
  my: 0,
  width: "initial",
};

const menuItemStyles = {
  padding: "1rem",
  "#crossBtn": {
    visibility: "hidden",
  },
  "&:hover": {
    "#crossBtn": {
      visibility: "initial",
    },
  },
  "@media (max-width: 768px)": {
    "#crossBtn": {
      visibility: "initial",
    },
  },
};

const notificationIconStyle = {
  background: "gray.1000",
  borderRadius: "8px",
  p: "7px",
  h: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const actionsBtnStyles = {
  h: "28px",
  px: "12px",
  fontSize: "12px",
  fontWeight: 500,
};

const avatarStyles = {
  h: "40px",
  w: "40px",
  borderStyle: "solid",
  borderWidth: "2px",
  borderColor: "gray.200",
};

const archiveAllStyles = {
  justifyContent: "flex-start",
  h: "38px",
  background: "gray.1000",
  button: {
    background: "transparent",
    fontSize: "16px",
    fontWeight: 400,
    color: "brand.negative",
    _hover: {
      background: "transparent",
      color: "red.500",
    },
    _active: {
      background: "transparent",
      color: "red.500",
    },
  },
  "@media (max-width: 768px)": {
    justifyContent: "center",
  },
};

const actionsStyles = {
  fontSize: "14px",
  fontWeight: 400,
  color: "gray.100",
};

const menuListMobile = {
  width: "100vw",
  position: "absolute",
  left: 0,
  height: "100vh",
  top: 0,
  zIndex: 1,
  background: "brand.dark_05",
  ms: "0 !important"
};

function TldrNotificationDropdown() {
  const signal = axios.CancelToken.source();
  const { t } = useTranslation(["navbar"]);
  const history = useHistory();
  const notifications = useSelector((state) => state.navbar.usersNotifications);
  const page = useSelector((state) => state.navbar.page);
  const hasMore = useSelector((state) => state.navbar.hasMore);
  const newNotification = useSelector((state) => state.navbar.newNotification);
  const isMobileView = useSelector((state) => state.app.isMobileView);

  const workspace = useSelector((state) =>
    state.auth.payload?.orgs?.find(
      (item) => item.id === state.auth.payload?.selectedOrg
    )
  );
  const dispatch = useDispatch();
  const [loading, isLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  useEffect(() => {
    dispatch(wsNotification());
  }, [history.location.pathname]);

  useEffect(() => {
    return () => {
      dispatch(resetNotification());
    };
  }, []);

  const getNotifications = (page, setDrawer = false) => {
    if (isMobileView && setDrawer) setIsNotificationOpen(!isNotificationOpen);
    isLoading(true);
    dispatch(
      fetchUserNotifications(
        signal,
        { history: history },
        workspace.id,
        page,
        isLoading
      )
    );
  };

  const loadMoreNotification = () => {
    getNotifications(page);
  };

  const removeNotification = (e, id) => {
    e.stopPropagation();
    setDeleteLoading(true);
    dispatch(
      deleteUserNotification(signal, { history: history }, id, setDeleteLoading)
    );
  };

  const readNotification = (e, id, link, isReaded) => {
    e.stopPropagation();
    let redirectLink;
    if (link) redirectLink = "/" + link.split("/").splice(3).join("/");
    if(isReaded) return history.push(redirectLink);
    dispatch(
      readUserNotification(signal, { history: history }, id, redirectLink)
    );
  };

  const clearAllNotifications = (e) => {
    e.stopPropagation();
    dispatch(clearUserNotifications(signal, { history: history }));
  };

  const readAllNotifications = (e) => {
    e.stopPropagation();
    dispatch(readAllUserNotifications(signal, { history: history }));
  };

  const menuList =
    notifications &&
    notifications.map((item, index) => {
      return (
        <Fragment key={item.id}>
          <MenuItem
            sx={menuItemStyles}
            as={Box}
            background={item.is_read ? "brand.dark" : "transparent"}
            _hover={{
              background: item.is_read ? "brand.darker" : "brand.dark",
            }}
          >
            <Flex justifyContent="space-between" w="full">
              <Flex alignItems="flex-start" pos="relative" pl={3}>
                {!item.is_read && (
                  <Badge
                    position="absolute"
                    zIndex={1}
                    top="13px"
                    left="-4px"
                    variant="solid"
                    height="8px"
                    width="8px"
                  />
                )}
                {item.image ? (
                  <Avatar sx={avatarStyles} src={item.image} />
                ) : (
                  <Box sx={notificationIconStyle}>
                    <Icon
                      as={
                        item.category === "postPublished" ? FaCalendar : FaRobot
                      }
                      color="gray.100"
                    />
                  </Box>
                )}
              </Flex>

              <Box w="262px" pr="1">
                <Text fontSize={{ base: "1rem", md:"0.875rem"}} color="brand.white">
                  {item.title}
                </Text>
                <Text fontSize={{ base: "0.875rem", md:"0.75rem"}} color="gray.300">
                  {formatDistance(new Date(item.created), new Date(), {
                    addSuffix: true,
                  })}
                  <Icon as={BsDot} />
                  Content Planner{" "}
                </Text>
                {item?.link && (
                  <ButtonGroup mt="3">
                    <Button
                      variant="secondary"
                      type="button"
                      sx={actionsBtnStyles}
                      onClick={(e) => readNotification(e, item.id, item.link, item.is_read)}
                    >
                      {t("notification.view_post_btn")}
                    </Button>
                  </ButtonGroup>
                )}
              </Box>
              <Menu isLazy autoSelect={false}>
                <MenuButton
                  as={Button}
                  variant="ghost"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Icon as={BsThreeDotsVertical} id="crossBtn" />
                </MenuButton>
                <MenuList
                  zIndex={1005}
                  sx={itemActionStyle}
                  pb={item.is_read ? "0" : ""}
                >
                  {!item.is_read && (
                    <Tooltip
                      hasArrow
                      placement="bottom-start"
                      label={t("notification.mark_as_read")}
                    >
                      <MenuItem
                        sx={actionsStyles}
                        onClick={(e) => readNotification(e, item.id)}
                      >
                        <Icon as={FaCheckDouble} mr="2" />{" "}
                        {t("notification.mark_as_read")}
                      </MenuItem>
                    </Tooltip>
                  )}
                  <Tooltip
                    placement="bottom-start"
                    hasArrow
                    label={t("notification.clear_btn")}
                  >
                    <MenuItem
                      sx={actionsStyles}
                      onClick={(e) => removeNotification(e, item.id)}
                    >
                      <Icon as={FaArchive} mr="2" />{" "}
                      {t("notification.clear_btn")}
                    </MenuItem>
                  </Tooltip>
                </MenuList>
              </Menu>
            </Flex>
          </MenuItem>
          <Divider sx={dividerStyles} mx="4" />
        </Fragment>
      );
    });

  const getMenuContent = () => {
    return (
      <>
        <Flex
          p="4"
          justifyContent="space-between"
          alignItems="baseline"
          background={isMobileView ? "brand.dark_04" : "transparent"}
        >
          <Flex alignItems="center">
            {isMobileView && (
              <Icon
                as={FaArrowLeft}
                mr="3"
                color="gray.100"
                size="16px"
                onClick={() => setIsNotificationOpen(false)}
              />
            )}
            <Text fontSize="1.25rem" fontWeight="500" color="brand.white">
              {t("notification.menu_header_notification")}
            </Text>
          </Flex>

          <Box>
            <Tooltip hasArrow label={t("notification.mark_all_as_read")}>
              <IconButton
                sx={readAllBtnStyle}
                onClick={(e) => readAllNotifications(e)}
                disabled={isEmpty(notifications)}
              >
                <Icon as={FaCheckDouble} fontSize="1rem" />
              </IconButton>
            </Tooltip>

            <Tooltip hasArrow label={t("notification.setting_btn")}>
              <IconButton
                sx={readAllBtnStyle}
                href="/settings/email-preferences"
                as={Link}
                ml="25px"
              >
                <Icon as={MdSettings} fontSize="1.25rem" />
              </IconButton>
            </Tooltip>
          </Box>
        </Flex>
        <Divider sx={dividerStyles} />
        {isEmpty(notifications) && loading && (
          <ShowCenterSpinner loaded={!loading} />
        )}
        {isEmpty(notifications) && loading && <Center h="219px"></Center>}
        {isEmpty(notifications) && !loading && (
          <Center h="219px">
            <Flex direction="column" justifyContent="center" w="305px">
              <Box sx={menuButtonStyle} id="iconBtn" alignSelf="center">
                <IoMdNotifications size="22px" />
                <Badge
                  position="absolute"
                  zIndex={1}
                  bottom="7px"
                  right="5px"
                  variant="solid"
                  height="8px"
                  width="8px"
                />
              </Box>
              <Text textAlign="center" color="gray.100" fontWeight="500">
                {t("notification.no_notification.title")}
              </Text>
              <Text textAlign="center" color="gray.300" fontSize="14px" mt="1">
                {t("notification.no_notification.message")}
              </Text>
            </Flex>
          </Center>
        )}
        {!isEmpty(notifications) && (
          <>
            <Box
              id="notification-list"
              h={isMobileView ? "calc(100vh - 102px)" : "373px"}
              overflowY="overlay"
            >
              <TLDRInfiniteScroll
                className="view-all-templates-infinite-scroll"
                childrens={menuList}
                hasMore={hasMore}
                loadMoreData={loadMoreNotification}
                scrollableTarget="notification-list"
                loaded={loading}
                showLoading
              />
              {loading && (
                <Center mb="3">
                  <Spinner size="sm" color="brand.primary" />
                </Center>
              )}
            </Box>
            <Flex sx={archiveAllStyles}>
              <Tooltip hasArrow label={t("notification.clear_all")}>
                <Button
                  variant="danger"
                  leftIcon={<Icon as={FaArchive} />}
                  onClick={(e) => clearAllNotifications(e)}
                >
                  {t("notification.clear_all")}
                </Button>
              </Tooltip>
            </Flex>
          </>
        )}
      </>
    );
  };

  return (
    <Menu isLazy autoSelect={false}>
      <Tooltip label={t("notification.title")}>
        <MenuButton
          as={IconButton}
          textAlign="left"
          fontWeight="normal"
          variant="ghost"
          borderRadius="full"
          size="sm"
          px={0}
          sx={menuStyle}
          onClick={() => getNotifications(1, true)}
        >
          <HStack sx={menuButtonStyle} id="iconBtn">
            <IoMdNotifications size="22px" />
            {newNotification && (
              <Badge
                position="absolute"
                zIndex={1}
                bottom="7px"
                right="5px"
                variant="solid"
                height="8px"
                width="8px"
              />
            )}
          </HStack>
        </MenuButton>
      </Tooltip>
      {isMobileView && isNotificationOpen && (
        <Box sx={menuListMobile}>{getMenuContent()}</Box>
      )}
      {!isMobileView && (
        <Portal appendToParentPortal={false}>
          <MenuList zIndex={1005} sx={menuListStyle}>
            {getMenuContent()}
          </MenuList>
        </Portal>
      )}
    </Menu>
  );
}

export default TldrNotificationDropdown;
